import { render, staticRenderFns } from "./TbcCreateApplication.vue?vue&type=template&id=c389bb5a&"
import script from "./TbcCreateApplication.vue?vue&type=script&lang=js&"
export * from "./TbcCreateApplication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports